require("./bootstrap");
require("alpinejs");
require('chart.js');
require('html2canvas');
